import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import user from '../services/UserService';
import { user_thunks } from '../constants/user';

const initialState = {
  authentication: {
    token: null,
    account: null,
  },
  uxSettings: null,
  marketingAlert: null,
  adviserAtFirmLocationId: null,
  error: null,
};

export const getUserUXSettings = createAsyncThunk(
  user_thunks.USER_GET_UX_SETTINGS,
  async (data, { rejectWithValue }) => {
    try {
      const response = await user.getUserUXSettings();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getUserMarketingAlerts = createAsyncThunk(
  user_thunks.USER_GET_MARKETING_ALERTS,
  async (data, { rejectWithValue }) => {
    try {
      const response = await user.getUserMarketingAlerts();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userLoginSuccess: (state, action) => {
      state.authentication.account = action.payload.account;
      state.authentication.token = action.payload.token;
    },
    userLogoutSuccess: () => {
      return initialState;
    },
    setAdviserAtFirmLocationId(state, action) {
      state.adviserAtFirmLocationId = action.payload;
    },
  },
  extraReducers: {
    [getUserUXSettings.pending]: (state) => {
      state.loading = true;
    },
    [getUserUXSettings.fulfilled]: (state, action) => {
      state.uxSettings = action.payload.data;
      state.loading = false;
    },
    [getUserUXSettings.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getUserMarketingAlerts.pending]: () => {
      //
    },
    [getUserMarketingAlerts.fulfilled]: (state, action) => {
      state.marketingAlert = action.payload.data;
    },
    [getUserMarketingAlerts.rejected]: (state) => {
      state.marketingAlert = null;
    },
  },
});

export const {
  userLoginSuccess,
  userLogoutSuccess,
  setAdviserAtFirmLocationId,
} = userSlice.actions;

export default userSlice;
